import type { FaceLandmarker } from '@mediapipe/tasks-vision'
import { SELFIE_CONFIG as C } from './config'

/**
 * Lazily creates the MediaPipe FaceLandmarker (VIDEO mode, 2 faces) from the self-hosted assets. The library is imported
 * dynamically so it becomes its own chunk, loaded only when the photo step
 * opens. Tries the GPU delegate first and falls back to CPU.
 */
export async function loadLandmarker(): Promise<FaceLandmarker> {
  const { FaceLandmarker, FilesetResolver } = await import('@mediapipe/tasks-vision')
  const fileset = await FilesetResolver.forVisionTasks(C.assets.wasmDir)
  const make = (delegate: 'GPU' | 'CPU') =>
    FaceLandmarker.createFromOptions(fileset, {
      baseOptions: { modelAssetPath: C.assets.model, delegate },
      runningMode: 'VIDEO',
      numFaces: 2,
    })
  try {
    return await make('GPU')
  } catch {
    return make('CPU')
  }
}
